<div class="wrapper" #wrapperElement [ngClass]="{'wrapper--active': isDrawingMode}">
    <canvas class="canvas" #canvas [width]="width" [height]="height"></canvas>
    <app-keyboard
            [hidden]="!showKeyboard"
            cdkDrag
            cdkDragBoundary=".body"
            (closed)="onKeyboardClose()"
            (keyChoice)="onKeyboardOutput($event)"
    >
        <app-handle cdkDragHandle>
            <i class="fas fa-arrows-alt"></i>
        </app-handle>
    </app-keyboard>

    <app-calculator
            [hidden]="!showCalculator"
            cdkDrag
            cdkDragBoundary=".body"
            (closed)="onKeyboardClose()"
            (keyChoice)="onKeyboardOutput($event)"
    >
        <app-handle cdkDragHandle>
            <i class="fas fa-arrows-alt"></i>
        </app-handle>
    </app-calculator>
</div>
